export default {
  auth_request(state) {
    state.status = "loading";
  },

  auth_success(state, result) {
    state.status = "success";
    state.token = result.token;
    state.token_type = result.token_type;
    state.user = result.user;
    state.role = result.role;
    state.email = result.email;
    state.accountuid = result.accountuid;
    state.accountStatus = result.accountStatus;
    state.accountPass = result.accountPass;
  },

  remove_master(state) {
    state.masterkey = "";
  },

  set_profile(state, result) {
    state.accountStatus = result.status;
  },

  auth_error(state) {
    state.status = "error";
  },

  logout(state) {
    state.status = "";
    state.token = "";
    state.role = "";
  },

  //set Assets assets to state
  setAssets(state, data) {
    state.assets = data;
  },

  setRoles(state, data) {
    state.roles = data;
  },
};
